"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../java/lang/IllegalArgumentException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Octant =
/*#__PURE__*/
function () {
  function Octant() {
    _classCallCheck(this, Octant);

    Octant.constructor_.apply(this, arguments);
  }

  _createClass(Octant, [{
    key: "getClass",
    value: function getClass() {
      return Octant;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "octant",
    value: function octant() {
      if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
        var _dx = arguments[0],
            _dy = arguments[1];
        if (_dx === 0.0 && _dy === 0.0) throw new _IllegalArgumentException.default("Cannot compute the octant for point ( " + _dx + ", " + _dy + " )");
        var adx = Math.abs(_dx);
        var ady = Math.abs(_dy);

        if (_dx >= 0) {
          if (_dy >= 0) {
            if (adx >= ady) return 0;else return 1;
          } else {
            if (adx >= ady) return 7;else return 6;
          }
        } else {
          if (_dy >= 0) {
            if (adx >= ady) return 3;else return 2;
          } else {
            if (adx >= ady) return 4;else return 5;
          }
        }
      } else if (arguments[0] instanceof _Coordinate.default && arguments[1] instanceof _Coordinate.default) {
        var p0 = arguments[0],
            p1 = arguments[1];
        var dx = p1.x - p0.x;
        var dy = p1.y - p0.y;
        if (dx === 0.0 && dy === 0.0) throw new _IllegalArgumentException.default("Cannot compute the octant for two identical points " + p0);
        return Octant.octant(dx, dy);
      }
    }
  }]);

  return Octant;
}();

exports.default = Octant;

Octant.constructor_ = function () {};